import React from 'react'

import { ZariContext } from '_zari/context'

import { Portlet } from '_zari/core'

import { CodigosTransaccionesConstant } from 'constants/index'

import * as UsuarioService from 'services/usuario.service'

import { IdGen } from 'utils'

import NuevoMainForm from './mainForm'

const NuevoUsuarioPage = ({ match }) => {
  const __zariContext = React.useContext(ZariContext)

  const [__keyMainForm, setKeyMainForm] = React.useState(null)

  const editarDataRef = React.useRef({})

  const portletBreadcrumbs = React.useMemo(() => {
    if (match.params.id) {
      return [{ name: 'Usuarios', path: `/${CodigosTransaccionesConstant.USUARIOS_LISTA}` }, { name: 'Editar' }]
    }
    return [{ name: 'Usuarios', path: `/${CodigosTransaccionesConstant.USUARIOS_LISTA}` }, { name: 'Nuevo' }]
  }, [match.params.id])

  React.useEffect(() => {
    if (match.params.id) {
      UsuarioService.obtenerxIdAsEdicion(match.params.id)
        .then(({ data }) => {
          editarDataRef.current = data
          setKeyMainForm(IdGen.newId())
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    } else {
      setKeyMainForm(IdGen.newId())
    }
  }, [match.params, __zariContext])

  return (
    <Portlet>
      <Portlet.Header title='NUEVO USUARIO' breadcrumbs={portletBreadcrumbs} />
      <Portlet.Body>{__keyMainForm && <NuevoMainForm key={__keyMainForm} editarData={editarDataRef.current} />}</Portlet.Body>
    </Portlet>
  )
}

export default NuevoUsuarioPage
